import { supabase } from '../lib/supabase'

export async function registerPhone(phone: string): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Usuário não autenticado')
  const { error } = await supabase.from('whatsapp_users').insert({ user_id: user.id, phone })
  if (error) {
    if (error.code === '23505') throw new Error('Este número já está vinculado a outra conta BagCash.')
    throw error
  }
}

export async function getRegisteredPhone(): Promise<string | null> {
  const { data } = await supabase.from('whatsapp_users').select('phone').maybeSingle()
  return data?.phone ?? null
}

export async function unregisterPhone(): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) throw new Error('Usuário não autenticado')
  await supabase.from('whatsapp_users').delete().eq('user_id', user.id)
}
